import { create } from 'zustand';

interface UseNetworkErrorStore {
  data: boolean;
  setNetworkError: (error: boolean) => void;
}

export const useNetworkErrorStore = create<UseNetworkErrorStore>((set) => ({
  data: false,

  setNetworkError: (error) => set(() => ({ data: error })),
}));
